import React, { useEffect, useState } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

const   Features = ({ id }) => {
  const [featureList, setfeatureList] = useState([]);
  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Facility/GetFacilityFeatures?facilityID=${id}`
      );
      if (list && list.length > 0) {
        setfeatureList(list);
      } else {
        setfeatureList([]);
      }
    } catch (error) {
      setfeatureList([]);
      console.error("Error fetching list:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  if (!featureList || featureList.length == 0) {
    return null;
  }
  return (
    <>
      <section className="wpo-Service-section-s3 section-padding" id="Service">
        <div className="container">
          <div className="wpo-Service-wrap">
            <div className="wpo-section-title">
              <h4>Features</h4>
              <div className="shape-2 wow fadeInUp custom-animation">
                <img src="/assets/images/Wedding/shape6.png" alt="shape" />
              </div>
            </div>
            <div className="row row-centered">
              {featureList.length > 0 ? (
                <>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <table className="table custom-table modern-table reduced-width">
                      <tbody>
                        {featureList
                          .slice(0, Math.ceil(featureList.length / 2))
                          .map((feature) => (
                            <tr key={feature.featuresID}>
                              <td>{feature.caption}</td>
                              <td>{feature.value}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <table className="table custom-table modern-table reduced-width">
                      <tbody>
                        {featureList
                          .slice(Math.ceil(featureList.length / 2))
                          .map((feature) => (
                            <tr key={feature.featuresID}>
                              <td>{feature.caption}</td>
                              <td>{feature.value}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </>
              ) : (
                <div>No features available for this facility.</div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Features;
